import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_PROMOTION_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class Promotion extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-kenaikan');
  }

  render() {
    const { handleGetPromotion } = this.props;
    return (
      <div className="promotion">
        <Button
          title="Tambah Surat Kenaikan"
          onClick={this.onClickAdd}
        />
        <div className="promotion__content">
          <ContentTable
            onSearchContent={handleGetPromotion}
            tableFields={PERSONAL_PROMOTION_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
Promotion.propTypes = {
  handleGetPromotion: PropTypes.func,
  history: PropTypes.object.isRequired,
};
Promotion.defaultProps = {
  handleGetPromotion: noop,
};
